module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Preface"
    }
  }, [_c('div', {
    staticClass: "fm-title"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('b', [_vm._v("Preface")])])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('div', {
    staticClass: "noindent1"
  }, [_vm._v("I came into the world in 1978 at the hospital of the University of Pennsylvania, a first generation American born to Indian immigrant parents. They were “fresh off the boat,” my father having literally arrived by boat, in 1959, and my mother (by plane) almost two decades later. My father wanted to call me Nature. He had already named my older sister Uni for “one” or “universal.” It was the ’70s and Dad was on a journey to find peace and enlightenment, especially in the wake of a divorce from his first wife. He was channeling his overarching philosophies of “unity in diversity” and “one ultimate reality” into our names (to this day, when my sister and I are together, he will address us as his “natural unity”). “Uni” had my dad’s hippie stamp all over it, and my mom was gearing up for a veto by the time I came along a year and a half later. When my dad suggested “Nature,” she rebutted with, “Sonia.” One is imbued with meaning; the other, well, easy to pronounce. Where would my father project his newfound "), _c('i', [_vm._v("kumbaya")]), _vm._v(" if I was called “Sonia”? He volleyed the veto. They eventually settled on Prakriti, the rough translation of nature in the Sanskrit language. My sister got two syllables and relative simplicity of pronunciation; I got three—and a plethora of quizzical and contorted faces whenever someone asked me my name.")]), _vm._v(" "), _c('div', {
    staticClass: "para"
  }, [_vm._v("I ended up creating the monosyllabic nickname “Pax,” meaning peace in Latin. Aligned with “Prakriti” in meaning, easy to pronounce, hard to butcher.")]), _vm._v(" "), _c('div', {
    staticClass: "para"
  }, [_vm._v("At times I wished my folks had gone with Nature. I grew up in the era of River Phoenix and his siblings, who had similarly granola-fied names like Sky and Leaf. I could have claimed to be their long-lost brown cousin, or at least gained some cool points telling kids at school my parents loved "), _c('i', [_vm._v("Stand by Me")]), _vm._v(" so much they too chose a crunchy name for their kid. But Nature I was not. I was Prakriti. If you Google it, these are the meanings and definitions associated with my name:")])]), _c('div', {
    staticClass: "disp-quote"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('div', {
    staticClass: "blist"
  }, [_vm._v("•"), _c('span', {
    staticClass: "bsp"
  }, [_vm._v("…The primal matter with three different innate qualities whose equilibrium is the basis for all observed empirical reality.")])]), _vm._v(" "), _c('div', {
    staticClass: "blist"
  }, [_vm._v("•"), _c('span', {
    staticClass: "bsp"
  }, [_vm._v("The feminine aspect of all life forms…a woman is seen as a symbol of Prakriti.")])]), _vm._v(" "), _c('div', {
    staticClass: "blist"
  }, [_vm._v("•"), _c('span', {
    staticClass: "bsp"
  }, [_vm._v("Making or placing before or at first, the original or natural form or condition of anything; original or primary substance.")])])]), _c('div', {
    staticClass: "blist"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("•"), _c('span', {
    staticClass: "bsp"
  }, [_vm._v("Nature, body matter, phenomenal universe.")])])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('div', {
    staticClass: "blist"
  }, [_vm._v("•"), _c('span', {
    staticClass: "bsp"
  }, [_vm._v("The personified will and energy of the Supreme (Brahman).")])]), _vm._v(" "), _c('div', {
    staticClass: "blist"
  }, [_vm._v("•"), _c('span', {
    staticClass: "bsp"
  }, [_c('i', [_vm._v("And one more")]), _vm._v(": The potency that brings about evolution and change in the empirical universe.")])])])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('div', {
    staticClass: "para"
  }, [_vm._v("Ah haaaaaaaaaa! Those extra “a’s” beyond the usual “A-ha!” moment indicate a compilation of thousands of moments—an entire existence—coming into crisper view. The trajectory of my life makes total sense in the context of my name. My journey has led me on a path toward effecting mass positive change on the planet as my life’s goal. I was literally "), _c('i', [_vm._v("born")]), _vm._v("—down to the name I was conferred at birth—to do this (help others find their way to well-being, that is). Before writing this page, I didn’t have such a specific notion of the meaning of my name; I knew it as “nature” or the “life force,” and that was a name to endeavor to live up to in and of itself. Now, I get it on a whole new level.")]), _vm._v(" "), _c('div', {
    staticClass: "para"
  }, [_vm._v("The subject matter of this book is the avatar of “Prakriti.” Scan back a bit and take another look at the interpretations and definitions I listed above. As you read along, hold them close to you and feel them channel through the material and my voice.")]), _vm._v(" "), _c('div', {
    staticClass: "para"
  }, [_vm._v("This book has taken a great deal of passion, dedication, and effort from me to write, and it hasn’t been a cakewalk: countless hours penning lines, sacrifices of time with friends and family to bring it to life, days of exhaustion and creative depletion.")]), _vm._v(" "), _c('div', {
    staticClass: "para"
  }, [_vm._v("It also hasn’t been a chore. I haven’t had to force the material or drive hard at the content; the words have poured forth fluidly and authentically, as if waiting to be written. Whether they were "), _c('i', [_vm._v("well")]), _vm._v(" written, now that tortured me a little. I’ll just hope you receive them with an open heart and a receptive mind, and that, as such, they speak to you, leading to positive change in your life. That’s my only angle.")]), _vm._v(" "), _c('div', {
    staticClass: "para"
  }, [_c('i', [_vm._v("Convergence")]), _vm._v(" is a word I use often to denote various elements colliding synchronistically at a single point in time. It implies a divine rightness to the moment, a magical unfolding that we are privy to if we choose to see it and are willing to embrace its messages. It’s the purest convergence as I sit here now, taking stock of my life from its inception, when I was given the name Prakriti. This name has tethered me to a purpose that brought me right here, to this moment, as I type these words onto a page while I look up the definitions of “Prakriti” and realize they are the very substrate of this book.")])]), _c('div', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('i', [_vm._v("Convergence")]), _vm._v(". Take a moment to close your eyes and whisper it to yourself, letting its meaning and magic sink into your cells. Know how to recognize it when it greets you in your life, and be ready to shake its hand and follow it where it wants you to go. Where it wanted me to go was right here: through a journey of life’s Byzantine pathways to a place where I could speak these truths and endeavor to provide the forces of change for you to find your own evolution (i.e., the last definition of “Prakriti” mentioned earlier). I surrendered to my purpose and became Prakriti (i.e., second-to-last definition) so I could write these words. And have them find their way to you.")])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('div', {
    staticClass: "para"
  }, [_vm._v("Life has handed me lemons, and I’ve learned to turn them into lemonade. Lemonade I now serve to you. I hope you’re thirsty, because we’re going to figure out how to help you find your flourishing, especially through your moments of greatest pain.")]), _vm._v(" "), _c('div', {
    staticClass: "para"
  }, [_vm._v("Here’s where mindfulness matters. Its practice is fundamental to success in virtually every area of your life. In addition, matters of health and well-being, like those in this book, inevitably come down to mindfulness. Learn to focus your attention on these areas, and you will see positive results.")])])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35c738fd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/06_Preface.vue
// module id = 72
// module chunks = 0